// src/components/Modals/AddChildOrganizationModal.js

import React, { useState,useEffect } from "react";
import { motion } from "framer-motion";
import { Building2 } from "lucide-react";
import {checkOfficeCode, fetchChildOrganizations} from "../api";
import axios from "axios";

const AddChildOrganizationModal = ({ onClose, onSubmit, loading }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    officeCode: "",
  });

  const [phoneError, setPhoneError] = useState("");
  const [officeCodeError, setOfficeCodeError] = useState("");
  const phoneRegex = /^\+?[0-9]{10,15}$/;

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (field === "phone") setPhoneError("");
    if (field === "officeCode") setOfficeCodeError("");
  };


  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email || !form.officeCode) {
      alert("Please fill in all required fields.");
      return;
    }
    if (!phoneRegex.test(form.phone)) {
      setPhoneError("Invalid phone number. Please enter a valid phone number (10-15 digits, optional +).");
      return;
    }
    try {
      const isValid = await checkOfficeCode(form.officeCode);
      if (!isValid) {
        setOfficeCodeError("Office code used. Use a different one.");
        return;
      }
    } catch (error) {
      setOfficeCodeError("Office code used. Use a different one.");
      return;
    }
    setPhoneError("");
    setOfficeCodeError("");
    onSubmit(form);
  };

  return (
    <motion.div
      className="fixed inset-0 z-[1000] bg-black bg-opacity-40 flex items-center justify-center px-fluid-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-2xl p-fluid-3 space-y-fluid-3"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        {/* Header */}
        <div className="flex flex-col items-center space-y-fluid-1">
          <div className="bg-[#1e2a74] rounded-full p-fluid-2 text-white">
            <Building2 size={28} />
          </div>
          <h2 className="text-fluid-xl font-semibold text-[#111827]">
            Add Child Organization
          </h2>
          <p className="text-fluid-base text-gray-600 text-center">
            Enter details to create a new child organization
          </p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 sm:grid-cols-2 gap-fluid-2 text-fluid-sm text-gray-800"
        >
          <div>
            <label className="block font-medium mb-1">Organization Name *</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="Enter name"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Phone *</label>
            <input
              type="text"
              value={form.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              required
              className={`w-full border rounded px-3 py-2 ${phoneError ? "border-red-500" : ""}`}
              placeholder="Enter phone"
            />
            {phoneError && (
                <div className="text-red-600 text-xs mt-1 flex items-center">
                  <span className="mr-1">&#9888;</span>
                  {phoneError}
                </div>
            )}
          </div>
          <div>
            <label className="block font-medium mb-1">Email *</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="Enter email"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Office Code *</label>
            <input
              type="text"
              value={form.officeCode}
              onChange={(e) => handleChange("officeCode", e.target.value)}
              required 
              className={`w-full border rounded px-3 py-2 ${officeCodeError ? "border-red-500" : ""}`}
              placeholder="Enter office code"
            />
            {officeCodeError && (
                <div className="text-red-600 text-xs mt-1 flex items-center">
                  <span className="mr-1">&#9888;</span>
                  {officeCodeError}
                </div>
            )}
          </div>

          {/* Buttons */}
          <div className="col-span-full flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200 mt-fluid-2">
            <button
              type="button"
              onClick={onClose}
              className="px-fluid-button-x py-fluid-button-y border border-gray-300 rounded text-gray-700 hover:bg-gray-100 text-fluid-sm transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-fluid-button-x py-fluid-button-y bg-[#1e2a74] text-white hover:bg-[#18225c] text-fluid-sm rounded font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Adding..." : "Add Organization"}
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default AddChildOrganizationModal;
